import BankFlatListData from '@atoms/BankFlatListData';
import SkeletonComponent from '@atoms/SkeletonComponent';
import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';

type Bank = {
  bankBranch: string;
  bankCode: string;
  bankName: string;
};

type BankItem = {
  accountNumber: string;
  bank: Bank;
  beneficiaryName: string;
  createdAt: string;
  id: number;
  nickname?: string;
  status: string;
};

type BankListProps = {
  bankList?: BankItem[];
  fromTransfer?: boolean;
  setBankForTransfer?: (bank: BankItem) => void;
};

type RouteParams = {
  source: string;
};

const BankList: React.FC<BankListProps> = ({ bankList = [], fromTransfer = false, setBankForTransfer = () => {} }) => {
  const route = useRoute<RouteProp<Record<string, RouteParams>, string>>();
  const { source } = route.params;

  if (fromTransfer && bankList && bankList.length === 0) {
    return <SkeletonComponent />;
  }

  if (bankList.length > 0) {
    return (
      <BankFlatListData
        bankList={bankList}
        fromTransfer={fromTransfer}
        setBankForTransfer={setBankForTransfer}
        source={source}
      />
    );
  }

  return null;
};

export default BankList;
